"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = require("react");
var _nipplejs = _interopRequireDefault(require("nipplejs"));
require("./styles.css");
var _colors = require("../../../styles/colors");
var _directionDecider = _interopRequireDefault(require("../../../utils/RCSequencer/direction-decider"));
var _calculateStepInterval = _interopRequireDefault(require("../../../utils/RCSequencer/calculateStepInterval"));
var _speedContext = _interopRequireDefault(require("../../../store/speed-context"));
var _Movement = _interopRequireDefault(require("../../../utils/RCSequencer/Movement"));
var _ = require("..");
var _RCSequencerManager = _interopRequireDefault(require("../../../utils/RCSequencer/RCSequencerManager"));
var _sequencerToggleContext = _interopRequireDefault(require("../../../store/sequencer-toggle-context"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let joystickPos = [0, 0];
let lastMovementSentOn = 0;
let jstInterval;
function padActionTimer(speed) {
  const moveTimeMs = (0, _calculateStepInterval.default)(speed);

  // Check for joystick moves
  if (joystickPos[0] < -0.1 || joystickPos[0] > 0.1 || joystickPos[1] < -0.1 || joystickPos[1] > 0.1) {
    // check if enought time has past from the last movement
    if (new Date().getTime() - lastMovementSentOn < moveTimeMs - 50) return;
    lastMovementSentOn = new Date().getTime();
    const direction = (0, _directionDecider.default)(joystickPos);
    let iconName = direction;
    if (iconName !== "dummy_doNothing") {
      let movement;
      if (iconName === "sidestepLeft" || iconName === "sidestepRight") {
        movement = new _Movement.default("step", iconName, speed, {
          // reduce step length if moveTime drops below 1 second
          stepLength: 0,
          turn: (joystickPos[0] * _.joystickTurnMaxDegs * -1).toFixed(1),
          moveTime: moveTimeMs
        });
      } else {
        movement = new _Movement.default("step", iconName, speed, {
          // reduce step length if moveTime drops below 1 second
          stepLength: (-joystickPos[1] * _.joystickStepMaxMM * Math.min(moveTimeMs / 1000, 1)).toFixed(1),
          turn: (joystickPos[0] * _.joystickTurnMaxDegs * -1).toFixed(1),
          moveTime: moveTimeMs
        });
      }
      _RCSequencerManager.default.addToSequence(movement, true);
      // }
    }
  }
}
const Joystick = () => {
  const sequencerToggleCtx = (0, _react.useContext)(_sequencerToggleContext.default);
  const joystickRef = (0, _react.useRef)(null);
  const speedCtx = (0, _react.useContext)(_speedContext.default);
  const jstMove = e => {
    // scalling positions to 0 - 1 range
    const xScaled = e.target.nipples[0].frontPosition.x / (e.target.nipples[0].options.size / 2);
    const yScaled = e.target.nipples[0].frontPosition.y / (e.target.nipples[0].options.size / 2);
    joystickPos[0] = xScaled;
    joystickPos[1] = yScaled;
    padActionTimer(speedCtx.speed);
  };
  const jstStarted = e => {
    jstInterval = setInterval(() => {
      jstMove(e);
    }, 10);
  };
  const jstEnded = e => {
    jstInterval && clearInterval(jstInterval);
  };
  (0, _react.useEffect)(() => {
    let jst;
    let nipple;
    if (joystickRef !== null && joystickRef !== void 0 && joystickRef.current) {
      const nippleSize = (joystickRef === null || joystickRef === void 0 ? void 0 : joystickRef.current.getBoundingClientRect().x) * 2;
      jst = _nipplejs.default.create({
        zone: document.getElementById("joystick-container"),
        mode: "static",
        position: {
          left: "50%",
          top: "50%"
        },
        color: _colors.MAIN_BLUE,
        size: nippleSize
      });
      nipple = jst.get(0);
      nipple.ui.back.remove();
      nipple.ui.front.classList.add("outer-nipple");
      jst.on("start", jstStarted);
      jst.on("end", jstEnded);
    }
    return () => {
      nipple.destroy();
      _nipplejs.default.factory.destroy();
      jst.destroy();
      jstInterval && clearInterval(jstInterval);
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      visibility: sequencerToggleCtx.sequencerToggle ? "hidden" : "visible"
    },
    className: "joystick-container",
    id: "joystick-container",
    ref: joystickRef
  });
};
var _default = exports.default = Joystick;